import * as yup from 'yup';
import { NumberSchema } from 'yup';
import { UserValidation } from '../../../../types';

export interface NumberValidation extends Pick<UserValidation, 'required' | 'min' | 'max'> {}

// build validation for number
export const buildNumberValidators = ({ required, min, max }: NumberValidation) => {
  let schema: NumberSchema<number | undefined | null, object> = yup.number();
  if (required) schema = schema.required(...required).nullable();
  if (min) schema = schema.min(Number(min[0]), min[1]).nullable();
  if (max) schema = schema.max(Number(max[0]), max[1]).nullable();
  return schema;
};
